export const AGENT_SERVICE_GUIDE_MESSAGES = [
  '「社内SE転職ナビ　エージェント」をご利用いただくと、弊社エージェントがあなたのご経歴、ご希望条件を元にマッチした求人をご提案。また、書類の添削、事前面接対策などあなたの転職成功までサポートしていきます。企業スカウトサービスと並行してご利用できますので、ぜひご利用ください。',
  '※ 「社内SE転職ナビ　エージェント」は、これまでのご経験やご希望内容によっては、残念ながらサービスのご提供ができない場合がございます。あらかじめご了承ください。',
  'ご利用される場合は利用規約をご確認・ご同意の上、利用開始してください。',
] as const;
